import { InfoPageModel } from "api"
import { Dispatch, SetStateAction } from "react"
import TextsPage from "./TextsPage"

type accessibilityProps = {
  data: InfoPageModel
  setRefList: Dispatch<SetStateAction<any[]>>
}

const AccessibilityPage = ({ data, setRefList }: accessibilityProps) => {
  return (
    <TextsPage
      title={data?.title}
      text={data?.body}
      setRefList={setRefList}
      align={"flex-start"}
    />
  )
}

export default AccessibilityPage
